module.exports = __webpack_public_path__ + "static/media/05-magazine.73746a83.png";